import type { WorkLocation } from '@/types/api'
import { createCrudService } from '../crud'

export type WorkLocationInput = Pick<
  WorkLocation,
  'name_en' | 'name_ru' | 'name_uz' | 'name_cyr' | 'status' | 'branch_ids'
>

export const workLocationsService = createCrudService<WorkLocation, WorkLocationInput>('work-locations')
